<ul *ngIf="links.length > 1">
    <li *ngFor="let link of links">{{link}}</li>
</ul>
<span *ngIf="links.length === 1">{{links[0]}}</span>